import { Button, ButtonGroup, ModalBody, ModalFooter, useToast } from "@chakra-ui/react";
import { useQueryClient } from "@tanstack/react-query";
import { Form, Modal } from "components";
import { API } from "config";
import { useState } from "react";

export default function AddOption({ ...props }){

    const queryClient = useQueryClient()
    const toast = useToast()
    const [ key, setKey ] = useState('')
    const [ value, setValue ] = useState('')
    const [ loading, setLoading ] = useState(false)

    const handleSubmit = async () => {
        setLoading(true)

        try {
            await API.post(`/options`, {key, value})
            toast({ title: 'Opção criada com sucesso.', status: 'success' })

            setKey('')
            setValue('')

            queryClient.invalidateQueries(['options'])
            props.onClose()
        } catch (error) {
            toast({ title: 'Não foi possível criar a opção.', description: error?.response?.data?.message, status: 'warning' })
        } finally {
            setLoading(false)
        }
    }

    return(
    <Modal title="Adicionar Opção" closeOnOverlayClick={!loading} {...props}>
        <ModalBody>
            <Form.Text
                required
                label="Nome da Opção:"
                placeholder="Nome"
                value={key}
                onChange={e => setKey(e.target.value)}
                isDisabled={loading}
            />
            <Form.Text
                required
                label="Valor da Opção:"
                placeholder="Valor"
                value={value}
                onChange={e => setValue(e.target.value)}
                isDisabled={loading}
            />
        </ModalBody>
        <ModalFooter>
            <ButtonGroup size="sm" w="100%" justifyContent="end">
                <Button colorScheme="orange" isLoading={loading} type="button" onClick={handleSubmit} children="Adicionar" />
                <Button colorScheme="blue" isLoading={loading} type="button" onClick={() => props.onClose()} children="Cancelar" />
            </ButtonGroup>
        </ModalFooter>
    </Modal>
    )
}
